import type { BonusSpinResult } from '../bonus/types';
import { PAYLINES } from '../core/paylines';
import type { SpinResult } from '../core/spin-engine';
import type { LineWin } from '../core/wins';
import type {
  PresentedLineWin,
  SlotGrid,
  SpinPresentationResult,
} from '../rendering/types';

export function adaptLineWin(lineWin: LineWin): PresentedLineWin {
  const route = PAYLINES[lineWin.lineIndex];
  if (route === undefined) throw new RangeError('Eine Gewinnlinie verweist auf eine unbekannte Route.');
  return Object.freeze({
    lineIndex: lineWin.lineIndex,
    route,
    count: lineWin.count,
    symbolId: lineWin.symbolId,
    winCents: lineWin.amountCents,
  });
}

function adaptGrid(spin: SpinResult): SlotGrid {
  // Both DTOs intentionally use the same immutable 5×3 Yu-Gi-Oh symbol tuple.
  return spin.grid;
}

export function presentBaseSpin(spin: SpinResult): SpinPresentationResult {
  return Object.freeze({
    grid: adaptGrid(spin),
    stops: spin.stops,
    scatterCount: spin.scatterCount,
    lineWins: Object.freeze(spin.lineWins.map(adaptLineWin)),
    totalWinCents: spin.totalWinCents,
    stickyBefore: Object.freeze([]),
    stickyAfter: Object.freeze([]),
    newlySticky: Object.freeze([]),
  });
}

export function presentBonusSpin(result: BonusSpinResult): SpinPresentationResult {
  return Object.freeze({
    grid: adaptGrid(result.spin),
    stops: result.spin.stops,
    scatterCount: result.spin.scatterCount,
    lineWins: Object.freeze(result.spin.lineWins.map(adaptLineWin)),
    totalWinCents: result.spin.totalWinCents,
    stickyBefore: result.stickyBefore,
    stickyAfter: result.stickyAfter,
    newlySticky: result.newStickyWilds,
    ...(result.retriggerAwarded > 0 ? { retriggerAwarded: result.retriggerAwarded } : {}),
    ...(result.pogEffect === null ? {} : { potOfGreed: result.pogEffect }),
    ...(result.godEvents.length === 0 ? {} : { godEvents: result.godEvents }),
  });
}
